// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"A4-z","subtitle":"B4-z","wrapper":"C4-z","leftArrow":"D4-z","rightArrow":"E4-z"};